import { render, staticRenderFns } from "./CustomersHousing.vue?vue&type=template&id=58d04eee&"
import script from "./CustomersHousing.vue?vue&type=script&lang=js&"
export * from "./CustomersHousing.vue?vue&type=script&lang=js&"
import style0 from "./CustomersHousing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports